var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8182 2H4.81818C3.81818 2 3 2.81818 3 3.81818V15.6364C3 16.1364 3.40909 16.5455 3.90909 16.5455C4.40909 16.5455 4.81818 16.1364 4.81818 15.6364V4.72727C4.81818 4.22727 5.22727 3.81818 5.72727 3.81818H14.8182C15.3182 3.81818 15.7273 3.40909 15.7273 2.90909C15.7273 2.40909 15.3182 2 14.8182 2ZM18.4545 5.63636H8.45455C7.45455 5.63636 6.63636 6.45455 6.63636 7.45455V20.1818C6.63636 21.1818 7.45455 22 8.45455 22H18.4545C19.4545 22 20.2727 21.1818 20.2727 20.1818V7.45455C20.2727 6.45455 19.4545 5.63636 18.4545 5.63636ZM17.5455 20.1818H9.36364C8.86364 20.1818 8.45455 19.7727 8.45455 19.2727V8.36364C8.45455 7.86364 8.86364 7.45455 9.36364 7.45455H17.5455C18.0455 7.45455 18.4545 7.86364 18.4545 8.36364V19.2727C18.4545 19.7727 18.0455 20.1818 17.5455 20.1818Z",
    fill: "#999999",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9fd8d16c8bf9e9b5883615e42c5f2297.svg";
export { ForwardRef as ReactComponent };